import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductsHistoryReport } from "./components/ProductsHistoryReport";

export const ProductsHistoryPage = () => {
	return (
		<>
			<HelmetDexteel title="Products History" />
			<ProductsHistoryReport />
		</>
	);
};
